import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import {
    SetFeatureInDetailsModal, setFeatureInDetailsModal
} from "../actions";
import LocationalState, {LocationalRoadObject} from "../LocationalState";
import {
    getSidePositionRelativeToMeteringDirection,
    sidePositionFromDomain
} from "../../../../sidePositionUtilities";
import {MeteringDirectionMissingError} from "../../../../meteringDirectionUtilities";
import {getRefLink} from "../../../../locationalUtilities";

interface TagProps {
    feature: LocationalRoadObject,
}

interface DispatchProps {
    doSetFeatureInDetailsModal: SetFeatureInDetailsModal
}

interface StateProps {
    disableDescriptiveName: boolean;
}


type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        disableDescriptiveName: selectors.disableDescriptiveName(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetFeatureInDetailsModal: setFeatureInDetailsModal
});

class Component extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    render() {
        const {feature, disableDescriptiveName} = this.props;
        return (
            <>
                <button className={"locationalInfoButton"} onClick={() => this.handleShowModal()} key={feature.id}>
                    <h4>{disableDescriptiveName ? feature.name : feature.descriptiveName}</h4>
                    {feature.locational?.locationals && feature.locational.locationals.map(
                        locational => {
                            let domainSidePositionRelativeToMeteringDirection;
                            try {
                                domainSidePositionRelativeToMeteringDirection = getSidePositionRelativeToMeteringDirection(locational);
                            } catch (err) {
                                if (err instanceof MeteringDirectionMissingError) {
                                    domainSidePositionRelativeToMeteringDirection = '';
                                }
                            }
                            const norwegianSidePositionRelativeToMeteringDirection = getNorwegianSidePosition(domainSidePositionRelativeToMeteringDirection);
                            const refLink = getRefLink(locational);
                            return (
                                <div key={refLink}>
                                    <span>Stedfesting: {refLink} {getNorwegianSidePosition(locational.sidePosition)} (Geom. retn.)</span>
                                    {
                                        locational.shortRoadSystemReference && <>
                                          <br/>
                                          <span>Vegsystemreferanse: {locational.shortRoadSystemReference} {norwegianSidePositionRelativeToMeteringDirection} (Metr. retn.)</span>
                                        </>
                                    }
                                </div>
                            )
                        }
                    )}
                    {!feature.locational?.locationals && (
                        <span>Mangler stedfesting</span>
                    )}
                </button>
                {feature.locational?.locationals && <span>Geom. retn. - Geometriretning <br/> Metr. retn. - Metreringsretning</span>}
            </>
        );
    }

    handleShowModal() {
        this.props.doSetFeatureInDetailsModal(this.props.feature.id);
    }
}

function getNorwegianSidePosition(sidePosition: string) {
    let norwegianSidePosition: string = "";
    if (sidePosition !== undefined) {
        norwegianSidePosition = sidePositionFromDomain(sidePosition);
    }
    return norwegianSidePosition;
}

export const RoadObjectInfoFeature = connect(mapStateToProps, mapDispatchToProps)(Component);
